export const ScopeDocumentEnum = {
    Unit: { scopeTypeId: 58242 },
    Contact: { scopeTypeId: 58240 },
    Lead: { scopeTypeId: 58243 },
    Property: { scopeTypeId: 58241 },
    DeveloperDocument: { scopeTypeId: 63871 }
};
